var map = {
	"./images/html-css.png": 614
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1487;


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations ^.*\/html\-css\.png$
// module id = 1487
// module chunks = 147